/** @jsxImportSource @emotion/react */
import React from "react";
import { menuIconStyle, menuItemStyle } from "./DropdownItemLink";
import { StyledText } from "../../assets/typography/typography";
import { SerializedStyles, css } from "@emotion/react";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  icon: React.ReactNode;
  additionalStyles?: SerializedStyles;
  type?: "button" | "submit" | "reset";
}

export const DropdownItemButton = ({
  children,
  additionalStyles,
  icon,
  ...rest
}: Props) => {
  const extendedMenuItemStyle = css`
    ${menuItemStyle}
    ${additionalStyles}
  `;

  return (
    <button css={extendedMenuItemStyle} {...rest}>
      <div css={menuIconStyle}>{icon}</div>
      <StyledText className="bodyTextSemibold mb-0">{children}</StyledText>
    </button>
  );
};
